<template>
  <div>
    <vxe-form
        ref="xForm"
        class="my-form3"
        title-align="right"
        title-width="110"
        :data="formData"
        :rules="formRules"
        @submit="submitEvent">
      <vxe-form-item title="注册手机号" field="phoneNum" span="24">
        <template v-slot="scope">
          <vxe-input
              v-model="formData.phoneNum"
              placeholder="请输入手机号"
              @input="$refs.xForm.updateStatus(scope)"
              style="width: 400px"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="登录密码" field="password" span="24">
        <template v-slot="scope">
          <vxe-input
              v-model="formData.password"
              type="password"
              placeholder="请输入密码"
              @input="$refs.xForm.updateStatus(scope)"
              style="width: 400px"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="账号类型" field="isTester" span="24">
        <template>
          <vxe-select
              style="width: 400px"
              v-model="formData.isTester"
              placeholder="请选择"
              :options="testerOption"
              transfer
              @change="$refs.xForm.clearValidate()"
          ></vxe-select>
        </template>
      </vxe-form-item>
      <vxe-form-item title="身份类型" field="tagsStr" span="24">
        <template>
          <vxe-select
              style="width: 400px"
              v-model="formData.tagsStr"
              placeholder="请选择"
              :options="userCategoryType"
              transfer
              multiple
              @change="$refs.xForm.clearValidate()"
          ></vxe-select>
        </template>
      </vxe-form-item>
      <vxe-form-item align="center" span="24">
        <template v-slot>
          <vxe-button type="submit" status="primary">提交注册</vxe-button>
        </template>
      </vxe-form-item>
    </vxe-form>
  </div>
</template>
<script>
import $api from "@/apiProvider";
import {hideLoading, showLoading} from "@/utils/util";
import md5 from "js-md5";

export default {
  data() {
    return {
      formData: {
        phoneNum: null,
        password: null,
        isTester: null,
        tagsStr: []
      },
      formRules: {
        phoneNum: [{required: true, message: "请输入注册手机号"}],
        password: [{required: true, message: "请输入密码"},
          {min: 6, message: "密码长度不少于6个字符"}],
        isTester: [{required: true, message: "请选择账号类型"}],
        tagsStr: [{required: true, message: "请选择身份类型"}],
      },
      testerOption: [
        {
          label: '用户',
          value: 0
        },
        {
          label: '内部',
          value: 1
        }],
      userCategoryType: [{
        label: '货主',
        value: '货主'
      },
        {
          label: '船东',
          value: '船东'
        },
        {
          label: '司机',
          value: '司机'
        },
        {
          label: '代理',
          value: '代理'
        },
        {
          label: '船员',
          value: '船员'
        },
        {
          label: '供应商',
          value: '供应商'
        },
        {
          label: '其他',
          value: '其他'
        }
      ],
    }
  },
  methods: {
    async submitEvent() {
      let regPhone = new RegExp(/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/);
      let validPhone = regPhone.test(this.formData.phoneNum);
      if (this.formData.phoneNum && this.formData.phoneNum !== '' && this.formData.phoneNum.length !== 11 && !validPhone) {
        this.$XModal.alert({
          message: "请输入正确的注册手机号",
          status: "error",
        });
        return;
      }
      let reg = /((^[0-9]{6,})|(^[a-z]{6,})|(^[A-Z]{6,}))$/;
      if (reg.test(this.formData.password)) {
        this.$XModal.alert({
          message: "密码强度过低，请重新设置密码",
          status: "error",
        });
        return;
      }

      let obj = Object.assign({}, this.formData);
      obj.password = md5(obj.password);
      obj.tagsStr = obj.tagsStr.toString();

      showLoading();
      let res = await $api.gcdUser.request("addUserInfoClient", obj);
      hideLoading();
      if (res.status === 1) {
        this.$Message.success('提交成功');
        this.$emit('afterSave');
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }

    }
  }
}
</script>
<style>

</style>